import { render, staticRenderFns } from "./BasicDialog.vue?vue&type=template&id=58861013&"
import script from "./BasicDialog.vue?vue&type=script&lang=ts&"
export * from "./BasicDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports